// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b8814c7f4d93ba8919d4","655":"f26dfc06ffb277da7697"}[chunkId] + ".js";
};